import { render, staticRenderFns } from "./ModalRejected.vue?vue&type=template&id=79424738&"
import script from "./ModalRejected.vue?vue&type=script&lang=ts&"
export * from "./ModalRejected.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports